var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.img_url + _vm.material.pc_sl_img),expression:"img_url + material.pc_sl_img"}],staticClass:"xfc",on:{"click":_vm.sup_tc}})])}
var staticRenderFns = []

export { render, staticRenderFns }